import { Controller } from "@hotwired/stimulus"
import Sortable, { MultiDrag } from "sortablejs"
import { ajax } from "@rails/ujs"
import $ from "jquery"

Sortable.mount(new MultiDrag())

export default class extends Controller {
  static targets = ["column", "headerDrop"]
  static values = { url: String, runOn: String }

  connect() {
    const sharedOptions = {
      group: "route-orders",
      multiDrag: true,
      selectedClass: "sortable-selected",
      animation: 150,
      ghostClass: "list-group-item-info",
      emptyInsertThreshold: 20,
      forceFallback: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      revertOnSpill: true,
      handle: ".dragger",
      onStart: this.startSpillTracking.bind(this)
    }

    this.handlePointerMove = this.handlePointerMove.bind(this)

    this.sortables = this.columnTargets.map((column) => new Sortable(column, {
      ...sharedOptions,
      onEnd: this.moved.bind(this)
    }))

    this.dropSortables = this.headerDropTargets.map((dropzone) => new Sortable(dropzone, {
      ...sharedOptions,
      sort: false,
      filter: ".no-drag",
      onAdd: this.droppedOnHeader.bind(this)
    }))
  }

  disconnect() {
    this.sortables.forEach((sortable) => sortable.destroy())
    this.dropSortables.forEach((sortable) => sortable.destroy())
    this.sortables = []
    this.dropSortables = []
    this.stopSpillTracking()
  }

  moved(event) {
    this.stopSpillTracking()

    if (event.to.dataset.orderBoardTarget === "headerDrop") return

    const items = event.items && event.items.length ? event.items : [event.item]
    this.persist(event.to, items)
  }

  startSpillTracking() {
    document.addEventListener("mousemove", this.handlePointerMove)
    document.addEventListener("touchmove", this.handlePointerMove, { passive: true })
  }

  stopSpillTracking() {
    document.removeEventListener("mousemove", this.handlePointerMove)
    document.removeEventListener("touchmove", this.handlePointerMove)
    document.body.classList.remove("order-board-spill")
  }

  handlePointerMove(event) {
    const point = event.touches ? event.touches[0] : event
    const target = document.elementFromPoint(point.clientX, point.clientY)
    const overTarget = target && target.closest('.route-orders, [data-order-board-target="headerDrop"]')
    document.body.classList.toggle("order-board-spill", !overTarget)
  }

  droppedOnHeader(event) {
    const routeId = event.to.dataset.routeId
    const column = this.columnTargets.find((target) => target.dataset.routeId === routeId)
    const items = event.items && event.items.length ? event.items : [event.item]
    items.forEach((item) => column.appendChild(item))
    this.persist(column, items)
  }

  persist(column, items) {
    document.querySelectorAll(".sortable-selected").forEach((item) => Sortable.utils.deselect(item))

    const isSpur = column.dataset.spur === "true"
    items.forEach((item) => item.classList.toggle("list-group-item-warning", isSpur))

    Array.from(column.children).forEach((row) => {
      row.classList.remove("alert-danger")
      row.dataset.sequenced = "true"
      const badge = row.querySelector(".unsequenced-badge")
      if (badge) badge.remove()
    })

    const orderIds = items.map((item) => item.dataset.id)
    const addresses = Array.from(column.children).map((row) => row.dataset.address)

    const body = new URLSearchParams()
    body.append("route_id", column.dataset.routeId)
    body.append("run_on", this.runOnValue)
    orderIds.forEach((id) => body.append("order_ids[]", id))
    addresses.forEach((address) => body.append("addresses[]", address))

    ajax({
      url: this.urlValue,
      type: "PATCH",
      data: body.toString(),
      success: (response) => {
        this.updateStopCounts(response.stop_counts)
        this.updateMapboxTiming(response.mapbox_timing_dom_id, response.mapbox_timing_html)
      }
    })
  }

  updateStopCounts(stopCounts) {
    if (!stopCounts) return

    Object.entries(stopCounts).forEach(([routeId, count]) => {
      const routeEl = document.getElementById(`orders-${routeId}`)
      if (routeEl) routeEl.classList.toggle("board-route-empty", count === 0)

      const dropzone = document.querySelector(`#orders-${routeId} [data-order-board-target="headerDrop"]`)
      if (!dropzone) return

      dropzone.classList.toggle("badge-dark", count > 0)

      const dropCount = dropzone.querySelector(".header-drop-count")
      if (dropCount) dropCount.textContent = count
    })
  }

  updateMapboxTiming(domId, html) {
    if (!domId || !html) return

    const element = document.getElementById(domId)
    if (element) element.outerHTML = html
  }

  toggleEmptyRoutes(event) {
    this.element.classList.toggle("hide-empty-routes", !event.target.checked)
  }

  toggleShowAll(event) {
    if (event.target.checked) {
      this.expandAll()
    } else {
      this.collapseAll()
    }
  }

  expandAll() {
    $(".board-route-collapse").collapse("show")
    document.querySelectorAll(".board-route-toggle").forEach((checkbox) => { checkbox.checked = true })
  }

  collapseAll() {
    $(".board-route-collapse").collapse("hide")
    document.querySelectorAll(".board-route-toggle").forEach((checkbox) => { checkbox.checked = false })
  }
}
